import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import "@/styles/index.scss";
import "antd/dist/antd.css";

import App from "./App";
import ReduxProvide from "@/components/ReduxProvide";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <ReduxProvide>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </ReduxProvide>
);
